import React from "react";
import { useAppSelector } from "../../app/hooks";

import {
  selectlistOfFarmesNameAndAboutMe,
  selectStatusListOfFarmes,
} from "../../features/produtores/produtoresSlice";

//MaterialUI
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
// import Divider from "@mui/material/Divider";

//Compojtnets
import ProdutorCard from "./ProdutorCard";

export default function ListaProdutores() {
  // const lista = [1, 2, 3, 4, 5, 6];
  const listOfFarmesNameAndAboutMe = useAppSelector(
    selectlistOfFarmesNameAndAboutMe
  );
  const statusListOfFarmes = useAppSelector(selectStatusListOfFarmes);

  return (
    <React.Fragment>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container>
          {statusListOfFarmes === "success" &&
            listOfFarmesNameAndAboutMe.map((produtor) => {
              return (
                <React.Fragment key={produtor.docId}>
                  <Grid item xs={4} sm={3} md={2} lg={1} xl={1}>
                    <Box padding={1}>
                      <ProdutorCard produtor={produtor} />
                    </Box>
                  </Grid>
                </React.Fragment>
              );
            })}
          {/* {lista.map((numero) => {
            return (
              <React.Fragment key={numero}>
                <Grid item xs={12}>
                  <Box padding={2}>
                    <ProdutorCard />
                  </Box>
                  <Divider />
                </Grid>
              </React.Fragment>
            );
          })} */}
        </Grid>
      </Box>
    </React.Fragment>
  );
}
